import { API_URL, CapitalizeFirstWord } from "../../helpers/utils";
import axios from "../../helpers/axios";
import {
  catchHandler,
  dispatchError,
  dispatchLoading,
  dispatchToast,
  elseHandler,
} from "../../helpers/dispatch";
import {
  decryptByText,
  requestPayloadBodyFormate,
  responseDataFormate,
} from "../../helpers/bycrypt";
import { NavigateFunction } from "react-router-dom";
import axiosInstance from "../../helpers/axios";

export const GetDepartmentListAPI =
  (
    { page, limit, search, is_active, sortBy, sortOrder }: any,
    setHasMore: any,
  ) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getDepartment", true);
    let params: any = {};
    if (page) params["page"] = page;
    if (limit) params["limit"] = limit;
    if (search) params["search"] = search;
    if (sortBy) params["sortBy"] = sortBy;
    if (sortOrder) params["sortOrder"] = sortOrder;
    if (is_active || is_active === 0) params["is_active"] = is_active;

    axiosInstance
      .get(`/departments`, {
        params: { ...params },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          const newData = result?.data?.departments?.map((dept: any) => ({
            ...dept,
            created_by: dept?.created_by
              ? {
                  ...dept?.created_by,
                  email: decryptByText(dept?.created_by?.email),
                  first_name: CapitalizeFirstWord(
                    decryptByText(dept?.created_by?.first_name),
                  ),
                  last_name: CapitalizeFirstWord(
                    decryptByText(dept?.created_by?.last_name),
                  ),
                }
              : dept?.created_by,
            updated_by: dept?.updated_by
              ? {
                  ...dept?.updated_by,
                  email: decryptByText(dept?.updated_by?.email),
                  first_name: CapitalizeFirstWord(
                    decryptByText(dept?.updated_by?.first_name),
                  ),
                  last_name: CapitalizeFirstWord(
                    decryptByText(dept?.updated_by?.last_name),
                  ),
                }
              : dept?.updated_by,
          }));
          dispatch({
            type: "GET_DEPARTMENT_DATA",
            payload: {
              page: page,
              data: newData,
              count: result?.data?.total,
            },
          });
          if (setHasMore) {
            setHasMore(result?.data?.departments?.length == limit);
          }
        } else {
          elseHandler(dispatch, "getDepartment", result);
          // navigate("/auth/login");
        }
        dispatchLoading(dispatch, "getDepartment", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getDepartment")(err);
        // navigate("/auth/login");
      });
  };
export const GetDepartmentListByProductAPI =
  ({ product_id, page, limit, search, is_active, sortBy, sortOrder }: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getDepartmentByProduct", true);
    let params: any = {};
    if (page) params["page"] = page;
    if (limit) params["limit"] = limit;
    if (search) params["search"] = search;
    if (sortBy) params["sortBy"] = sortBy;
    if (sortOrder) params["sortOrder"] = sortOrder;
    if (is_active || is_active === 0) params["is_active"] = is_active;

    axiosInstance
      .get(`/departments/${product_id}`, {
        params: { ...params },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "GET_DEPARTMENT_BY_PRODUCT_DATA",
            payload: result?.data?.departments,
          });
        } else {
          elseHandler(dispatch, "getDepartmentByProduct", result);
          // navigate("/auth/login");
        }
        dispatchLoading(dispatch, "getDepartmentByProduct", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getDepartmentByProduct")(err);
        // navigate("/auth/login");
      });
  };

export const AddDepartmentAPI =
  (data: any, onClose: any) => (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "addDepartment", true);
    const formatedData = requestPayloadBodyFormate(data);
    axios
      .post(`/departments`, formatedData, {
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          if (onClose) {
            onClose();
          }
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "addDepartment", undefined);
        } else elseHandler(dispatch, "addDepartment", result);
        dispatchLoading(dispatch, "addDepartment", false);
      })
      .catch((e) => {
        catchHandler(dispatch, "addDepartment")(e);
      });
  };

export const UpdateDepartmentDataAPI =
  (data: any, onClose: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updateDepartment", true);
    const formatedData = requestPayloadBodyFormate(data);
    axios
      .put(`/departments`, formatedData, {
        withCredentials: true,
      })
      .then((response: any) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          const newData = {
            ...result?.data,
            created_by: result?.data?.created_by
              ? {
                  ...result?.data?.created_by,
                  email: decryptByText(result?.data?.created_by?.email),
                  first_name: CapitalizeFirstWord(
                    decryptByText(result?.data?.created_by?.first_name),
                  ),
                  last_name: CapitalizeFirstWord(
                    decryptByText(result?.data?.created_by?.last_name),
                  ),
                }
              : result?.data?.created_by,
            updated_by: result?.data?.updated_by
              ? {
                  ...result?.data?.updated_by,
                  email: decryptByText(result?.data?.updated_by?.email),
                  first_name: CapitalizeFirstWord(
                    decryptByText(result?.data?.updated_by?.first_name),
                  ),
                  last_name: CapitalizeFirstWord(
                    decryptByText(result?.data?.updated_by?.last_name),
                  ),
                }
              : result?.data?.updated_by,
          };
          dispatch({
            type: "UPDATE_DEPARTMENT_DATA",
            payload: newData,
          });
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "updateDepartment", undefined);
          onClose();
        } else elseHandler(dispatch, "updateDepartment", result);
        dispatchLoading(dispatch, "updateDepartment", false);
      })
      .catch(catchHandler(dispatch, "updateDepartment"));
  };

export const DeleteDepartmentAPI =
  (data: any, onClose: any) => (dispatch: (action: any) => void) => {
    const formatedData = requestPayloadBodyFormate(data);
    dispatchLoading(dispatch, "deleteDepartment", true);
    axios
      .delete(`/departments`, {
        data: formatedData,
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          onClose();
          dispatch({
            type: "DELETE_DEPARTMENT",
            payload: data?.id,
          });
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "deleteDepartment", undefined);
        } else elseHandler(dispatch, "deleteDepartment", result);
        dispatchLoading(dispatch, "deleteDepartment", false);
      })
      .catch(catchHandler(dispatch, "deleteDepartment"));
  };

export const ReorderDepartmentsAPI =
	(data: any, onSuccess: any, onError: any) =>
	async (dispatch: (action: any) => void) => {
		dispatchLoading(dispatch, "reorderDepartment", true);
		axiosInstance
			.put(`/departments/reorder`, data)
			.then((response) => {
				let result = responseDataFormate(response?.data);
				if (result?.success) {
					dispatchToast(dispatch, "success", result?.message);
					onSuccess?.(result.data);
				} else {
					elseHandler(dispatch, "reorderDepartment", result);
					onError?.();
				}
				dispatchLoading(dispatch, "reorderDepartment", false);
			})
			.catch((err) => {
				catchHandler(dispatch, "reorderDepartment")(err);
				onError?.();
			});
	};

export const GetCategoryListAPI =
  ({ page, limit, search, is_active, sortBy, order }: any, setHasMore?: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getCategory", true);
    let params: any = {};
    if (page) params["page"] = page;
    if (limit) params["limit"] = limit;
    if (search) params["search"] = search;
    if (sortBy) params["sortBy"] = sortBy;
    if (order) params["order"] = order;
    if (is_active || is_active === 0) params["is_active"] = is_active;

    axiosInstance
      .get(`/product-categories`, {
        params: { ...params },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch({
            type: "GET_CATEGORY_DATA",
            payload: {
              page: page,
              data: result?.data,
              count: result?.pagination?.totalCount,
            },
          });
          if (setHasMore) {
            setHasMore(result?.length == limit);
          }
        } else {
          elseHandler(dispatch, "getCategory", result);
          // navigate("/auth/login");
        }
        dispatchLoading(dispatch, "getCategory", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getCategory")(err);
        // navigate("/auth/login");
      });
  };

export const GetHiredCompaniesListAPI =
  (
    { page, limit, search, is_active, sortBy, sortOrder,order }: any,
    setHasMore: any,
  ) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getHiredCompany", true);
    let params: any = {};
    if (page) params["page"] = page;
    if (limit) params["limit"] = limit;
    if (search) params["search"] = search;
    if (order) params["order"] = order;
    if (is_active || is_active === 0) params["is_active"] = is_active;

    axiosInstance
      .get(`/static-data/hired-companies`, {
        params: { ...params },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          const newData = result?.data?.data?.map((hirCom: any) => ({
            ...hirCom,
            created_by: hirCom?.created_by
              ? {
                  ...hirCom?.created_by,
                  email: decryptByText(hirCom?.created_by?.email),
                  first_name: CapitalizeFirstWord(
                    decryptByText(hirCom?.created_by?.first_name),
                  ),
                  last_name: CapitalizeFirstWord(
                    decryptByText(hirCom?.created_by?.last_name),
                  ),
                }
              : hirCom?.created_by,
            updated_by: hirCom?.updated_by
              ? {
                  ...hirCom?.updated_by,
                  email: decryptByText(hirCom?.updated_by?.email),
                  first_name: CapitalizeFirstWord(
                    decryptByText(hirCom?.updated_by?.first_name),
                  ),
                  last_name: CapitalizeFirstWord(
                    decryptByText(hirCom?.updated_by?.last_name),
                  ),
                }
              : hirCom?.updated_by,
          }));
          dispatch({
            type: "GET_HIRED_COMPANY_DATA",
            payload: {
              page: page,
              data: newData,
              count: result?.data?.count,
            },
          });
          if (setHasMore) {
            setHasMore(result?.data?.data?.length == limit);
          }
        } else {
          elseHandler(dispatch, "getHiredCompany", result);
          // navigate("/auth/login");
        }
        dispatchLoading(dispatch, "getHiredCompany", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getHiredCompany")(err);
        // navigate("/auth/login");
      });
  };

export const AddHiredCompanyAPI =
  (data: any, onClose: any) => (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "addHiredCompany", true);
    const formatedData = requestPayloadBodyFormate(data);
    axios
      .post(`/static-data/hired-companies`, formatedData, {
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          if (onClose) {
            onClose();
          }
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "addHiredCompany", undefined);
        } else elseHandler(dispatch, "addHiredCompany", result);
        dispatchLoading(dispatch, "addHiredCompany", false);
      })
      .catch((e) => {
        catchHandler(dispatch, "addHiredCompany")(e);
      });
  };

export const UpdateHiredCompanyAPI =
  (data: any, onClose: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updateHiredCompany", true);
    const formatedData = requestPayloadBodyFormate(data);
    axios
      .put(`/static-data/hired-companies`, formatedData, {
        withCredentials: true,
      })
      .then((response: any) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          const newData = {
            ...result?.data,
            created_by: result?.data?.created_by
              ? {
                  ...result?.data?.created_by,
                  email: decryptByText(result?.data?.created_by?.email),
                  first_name: CapitalizeFirstWord(
                    decryptByText(result?.data?.created_by?.first_name),
                  ),
                  last_name: CapitalizeFirstWord(
                    decryptByText(result?.data?.created_by?.last_name),
                  ),
                }
              : result?.data?.created_by,
            updated_by: result?.data?.updated_by
              ? {
                  ...result?.data?.updated_by,
                  email: decryptByText(result?.data?.updated_by?.email),
                  first_name: CapitalizeFirstWord(
                    decryptByText(result?.data?.updated_by?.first_name),
                  ),
                  last_name: CapitalizeFirstWord(
                    decryptByText(result?.data?.updated_by?.last_name),
                  ),
                }
              : result?.data?.updated_by,
          };
          dispatch({
            type: "UPDATE_HIRED_COMPANY_DATA",
            payload: newData,
          });
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "updateHiredCompany", undefined);
          onClose();
        } else elseHandler(dispatch, "updateHiredCompany", result);
        dispatchLoading(dispatch, "updateHiredCompany", false);
      })
      .catch(catchHandler(dispatch, "updateHiredCompany"));
  };

export const DeleteHiredCompanyAPI =
  (data: any, onClose: any) => (dispatch: (action: any) => void) => {
    const formatedData = requestPayloadBodyFormate(data);
    dispatchLoading(dispatch, "deleteHiredCompany", true);
    axios
      .delete(`/static-data/hired-companies/permanent`, {
        data: formatedData,
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          onClose();
          dispatch({
            type: "DELETE_HIRED_COMPANY",
            payload: data?.id,
          });
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "deleteHiredCompany", undefined);
        } else elseHandler(dispatch, "deleteHiredCompany", result);
        dispatchLoading(dispatch, "deleteHiredCompany", false);
      })
      .catch(catchHandler(dispatch, "deleteHiredCompany"));
  };

export const GetPricesheetVariablesInfoAPI =
  () => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getPricesheetVariablesInfo", true);
    axiosInstance
      .get(`/price-sheets/variables-info`)
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          const variablesInfo = result?.data;
          // Decrypt user info if present
          if (variablesInfo?.updated_by) {
            variablesInfo.updated_by = {
              ...variablesInfo.updated_by,
              email: decryptByText(variablesInfo.updated_by.email),
              first_name: CapitalizeFirstWord(decryptByText(variablesInfo.updated_by.first_name)),
              last_name: CapitalizeFirstWord(decryptByText(variablesInfo.updated_by.last_name)),
            };
          }
          dispatch({
            type: "GET_PRICESHEET_VARIABLES_INFO",
            payload: variablesInfo,
          });
        } else {
          elseHandler(dispatch, "getPricesheetVariablesInfo", result);
        }
        dispatchLoading(dispatch, "getPricesheetVariablesInfo", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getPricesheetVariablesInfo")(err);
      });
  };

export const UpdatePricesheetVariablesInfoAPI =
  (data: any, onSuccess: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updatePricesheetVariablesInfo", true);
    const formatedData = requestPayloadBodyFormate(data);
    axiosInstance
      .put(`/price-sheets/variables-info`, formatedData)
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          const variablesInfo = result?.data;
          if (variablesInfo?.updated_by) {
            variablesInfo.updated_by = {
              ...variablesInfo.updated_by,
              email: decryptByText(variablesInfo.updated_by.email),
              first_name: CapitalizeFirstWord(decryptByText(variablesInfo.updated_by.first_name)),
              last_name: CapitalizeFirstWord(decryptByText(variablesInfo.updated_by.last_name)),
            };
          }
          dispatch({
            type: "UPDATE_PRICESHEET_VARIABLES_INFO",
            payload: variablesInfo,
          });
          dispatchToast(dispatch, "success", result?.message);
          onSuccess?.();
        } else {
          elseHandler(dispatch, "updatePricesheetVariablesInfo", result);
        }
        dispatchLoading(dispatch, "updatePricesheetVariablesInfo", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "updatePricesheetVariablesInfo")(err);
      });
  };
